import './accountBenefitsBox.scss';

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ components
const  { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell} = require('commonsComponents/OKTableCell');
const { EmptyState } = require('commonsComponents/emptyState');
// @helpers
const { FormattedText } = require('core/i18n').i18n;
const MoneyHelper = require('utilities/currencyHelper');

class AccountBenefitsBox extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildEmptyState() {
        const { emptyStateText } = this.props;

        return (<EmptyState
            primaryText={emptyStateText}
        />);
    }

    buildSuccess() {

        const { title, immBenefits, total, latest, units } = this.props;

        return (
            <article className="account-benefits-box">
                <header>
                    <div className="account-benefits-box__title">
                        <OKBoxTitle
                            value={title}
                            isNotSeparator={true}
                            inline={true}
                        />
                        <div className="account-benefits-box__latest-settlement">
                            <div className="account-benefits-box__latest-settlement-label">
                                <FormattedText value="accountBenefits-latestSettlementShort" />
                            </div>
                            <div className="account-benefits-box__latest-settlement-value">
                                {MoneyHelper.formatAmount(latest)} {units}
                            </div>
                        </div>
                        <div className="account-benefits-box__total">
                            <div className="account-benefits-box__total-label">
                                <FormattedText value="accountBenefits-total" />
                            </div>
                            <div className="account-benefits-box__total-value">
                                {MoneyHelper.formatAmount(total)} {units}
                            </div>
                        </div>
                    </div>
                    <div className="pull-right">
                    </div>
                </header>
                <section>
                    <OKTable>
                        <thead>
                            <OKTableRow asHeader={true} modifier="inner-padding">
                                <OKTableCell asHeader={true} className="account-benefits-box__cell-total-benefits">
                                    <FormattedText value="accountBenefits-totalBenefits" format="uppercase" />
                                </OKTableCell>
                                <OKTableCell asHeader={true} className="account-benefits-box__cell-latest-settlement">
                                    <FormattedText value="accountBenefits-latestSettlement" format="uppercase" />
                                </OKTableCell>
                                <OKTableCell asHeader={true} className="account-benefits-box__cell-total">
                                    <FormattedText value="accountBenefits-total" format="uppercase" />
                                </OKTableCell>
                            </OKTableRow>
                        </thead>
                        <tbody>
                            {immBenefits.map((benefit, i) =>
                                (<OKTableRow key={i} modifier="inner-padding">
                                    <OKTableCell className="account-benefits-box__cell-total-benefits">
                                        {benefit.get('descripcion')}
                                    </OKTableCell>
                                    <OKTableCell className="account-benefits-box__cell-latest-settlement">
                                        {MoneyHelper.formatAmount(benefit.get('importeUltimaLiquidacion'))} {units}
                                    </OKTableCell>
                                    <OKTableCell className="account-benefits-box__cell-total">
                                        {MoneyHelper.formatAmount(benefit.get('totalAcumulado'))} {units}
                                    </OKTableCell>
                                </OKTableRow>)
                            )}
                        </tbody>
                    </OKTable>
                </section>
            </article>
        );
    }

    render() {
        const { immBenefits } = this.props;
        return immBenefits.size ? this.buildSuccess() : this.buildEmptyState();
    }
}

AccountBenefitsBox.propTypes = {
    title: PropTypes.string.isRequired,
    emptyStateText: PropTypes.string.isRequired,
    immBenefits: PropTypes.object.isRequired,
    total: PropTypes.string.isRequired,
    latest: PropTypes.string.isRequired,
    units: PropTypes.string
};

module.exports = AccountBenefitsBox;
